import React, { Component } from "react";
import appconfig from "../appconfig.json";
import axios from 'axios';


import { Provider } from 'react-redux';
import { store, persistedStore } from "App";
import { PersistGate } from "redux-persist/integration/react";

import { setToken } from "core/actions/common";
import {notSentOtpAlert,optNotRight,enterOtp} from "../Utils/helpers";
class OTPInputTesting extends Component {

  common = store.getState().common;

  nin = this.common.nin;
  name = this.common.fullName;
  mobile = this.common.mobile;
  serviceType = this.common.serviceType;


  verifyOtp = () => {
    let otp = document.getElementById('otp') as HTMLInputElement;
    if(otp.value == ''){
      //alert("برجاء ادخال رمز التحقق")
      enterOtp();
      return false;
    }
    let otp_url = "https://gosi-vv-webapi-prod.azurewebsites.net/api/verifyotp";
    const body = {
      "nin": this.nin,
      "otp": otp.value
    };
    const options = {
      headers: {
          "Content-Type" : "application/json"
      }
    };
    axios.post(otp_url, body , options).then(response => {
      console.log("Verify otp response = " + response);
      let message = response.data.Message;
     // alert(JSON.stringify(response));
      if (message == false) {
       // alert("رمز التحقق غير صحيح");
       optNotRight();
      } else {
        store.dispatch(setToken(response.data.token));
        window.location.href = "/?isPublic=true&config=true&fullname=" + this.name + "&nin=" + this.nin + "&mobile=" + this.mobile + "&serviceType=" + this.serviceType;
      }


    }).catch(err => {
      console.log(err);
     // alert(err);
     // alert("رمز التحقق غير صحيح");   
     optNotRight();
    });
    return true;
  }


  resendOtp = () => {
     
    let submitbtn = document.getElementById('resendOtp') as HTMLInputElement;
    let submitButtonSpinner = document.getElementById('submitButtonSpinner') as HTMLInputElement;
    
    submitButtonSpinner.style.display = '';
    submitbtn.disabled = true;
    
    let otp_url = appconfig.azure_reports_url + "/api/sendcustomerotp";
    const body = {
        "nin": this.nin,
        "mobile": this.mobile,
        "fullname": this.name
    };

    const options = {
        headers: {
            "Content-Type" : "application/json"
        }
      };

    axios.post(otp_url, body , options).then(response => {
        console.log("send otp response = " + response);
        //alert(JSON.stringify(response));
        if (response.data.successMessage) {
            window.location.href = "otp?isPublic=true&config=true";
        } else {
           submitButtonSpinner.style.display = 'none';
            submitbtn.disabled = false;
            //alert("Failed to send otp");
           // alert('تعذر ارسال رمز التحقق، الرجاء المحاولة في وقت لاحق');
           notSentOtpAlert();
        }
    }).catch(err => {
        submitButtonSpinner.style.display = 'none';
        submitbtn.disabled = false;
        console.log(err);
        //alert('تعذر ارسال رمز التحقق، الرجاء المحاولة في وقت لاحق');
        notSentOtpAlert();
    });
  }

  render() {

    return (
      <div className="content-container">
        <div style={{color:"red"}}>Testing</div>
        <div className='row'  >

          <div className='col-md-5 Rside'>
            <div className='row'>
              <div className='t2'>فرعنا الالكتروني <span className='t1'>عندك</span></div>
            </div>
            <div className='row'>
              <span className='p1 p2'>تتيح هذه الخدمة امكانية عقد <b>زيارة افتراضية </b>والتواصل مع موظف خدمة العملاء عبر الاتصال المرئى بكل سهولة ويسر</span>
            </div>
          </div>

          
          <div className='col-md-7'>
            <div className='leftSide'>
              <div className='row'>
                <div className='t1'>إبدأ من هنا</div>
              </div>

              <div className='row'>
                <div className='p1 p2'>  
أدخل رمز التحقق المرسل على رقم الجوال المسجل في ابشر
 </div>
              </div>

{/* 
            <br></br>
              <div className='row'>
                <span className='label1'>الجوال    </span>
              </div>


              <div className='row'>
                <span>{this.mobile?.substring(this.mobile.length-4,this.mobile.length)+"******"} </span>
              </div> */}

              <br></br>
              <div className='row'>
                <span className="mandatoryfield">*</span>
                <span className='label1'>رمز التحقق  </span>
              </div>

              <div className='row'>
                <input className='form-control' maxLength={4} type="text" placeholder='رمز التحقق' name='otp' id='otp' />
              </div>

              <br></br>
              <div className='row'>
                <button className="btn btn-success btn1" id="submitbtn" onClick={this.verifyOtp} data-i18n="submit_btn">استمرار</button>
                  &nbsp;&nbsp;
                <button className="btn btn-success btn1" id="resendOtp" onClick={this.resendOtp}>اعادة ارسال رمز التحقق
                      &nbsp;&nbsp;<span id="submitButtonSpinner" style={{display:"none"}} className="spinner-border spinner-border-sm"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


}

const OTPWrapperTesting = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistedStore}>
        <OTPInputTesting />
      </PersistGate>
    </Provider>
  )
}



export default OTPWrapperTesting;



